import { mergeTemplate } from './base-template';

export const fitnessTemplate = mergeTemplate({
  name: 'Fitness & Training',
  icon: '💪',
  settings: {
    primaryColor: '#dc2626',
    accentColor: '#fbbf24',
    darkMode: true,
    fontStack: 'dmsans',
    fxOrbs: true,
    fxIntensity: 'subtle',
    pageAngebot: {
      heroTitle: 'Training & Mitgliedschaft',
      heroSubtitle: 'Finde das passende Angebot für dein Ziel',
      packages: [
        { name: 'Probetraining', price: 'CHF 0', description: 'Unverbindlich reinschnuppern', features: 'Einführung, Geräteeinweisung, Probetraining, Beratungsgespräch', highlighted: false },
        { name: 'Mitgliedschaft', price: 'ab CHF 89/Mt.', description: 'Unbegrenzter Zugang zum Studio', features: 'Gerätetraining, Gruppenkurse, Umkleiden, Duschen, App-Zugang', highlighted: true },
        { name: 'Personal Training', price: 'ab CHF 120/Session', description: '1:1 Coaching für maximale Ergebnisse', features: 'Individuelle Trainingsplanung, Ernährungsberatung, Fortschrittstracking, Motivation', highlighted: false },
      ],
      ctaTitle: 'Starte jetzt',
      ctaText: 'Dein Probetraining ist kostenlos — komm vorbei und überzeug dich selbst.',
      ctaButtonText: 'Probetraining buchen',
    },
    pageMethoden: {
      heroTitle: 'Unsere Trainingsmethodik',
      heroSubtitle: 'Evidenzbasiert, individuell, effektiv',
      introText: 'Wir trainieren nicht nach Trends, sondern nach Wissenschaft. Jeder Trainingsplan wird individuell erstellt und regelmässig angepasst.',
      steps: [
        { title: 'Fitness-Check', description: 'Körperanalyse, Beweglichkeitstest, Zielbesprechung' },
        { title: 'Trainingsplan', description: 'Individueller Plan basierend auf deinen Zielen und deinem Level' },
        { title: 'Training', description: 'Begleitetes oder selbstständiges Training mit App-Support' },
        { title: 'Anpassung', description: 'Regelmässige Fortschrittschecks und Plananpassungen' },
      ],
      tools: [
        { name: 'InBody-Analyse', description: 'Präzise Körperkompositionsanalyse' },
        { name: 'Training-App', description: 'Dein Trainingsplan immer dabei' },
        { name: 'Herzfrequenz-Monitoring', description: 'Optimale Trainingssteuerung' },
      ],
      philosophyTitle: 'Unsere Fitness-Philosophie',
      philosophyText: 'Fitness ist kein Sprint, sondern ein Marathon. Wir helfen dir, nachhaltig stärker, fitter und gesünder zu werden.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Team',
      heroSubtitle: 'Qualifiziert, motiviert, persönlich',
      introText: 'Unsere Trainerinnen und Trainer bringen langjährige Erfahrung und echte Leidenschaft für Fitness mit.',
      timeline: [
        { year: '2015', text: 'Eröffnung des Studios' },
        { year: '2019', text: 'Erweiterung um Functional Training Bereich' },
        { year: '2023', text: 'Einführung der digitalen Trainingsplattform' },
      ],
      values: [
        { title: 'Individualität', description: 'Jeder Mensch ist anders — jeder Trainingsplan auch' },
        { title: 'Wissenschaft', description: 'Training basierend auf aktueller Sportwissenschaft' },
        { title: 'Community', description: 'Mehr als ein Gym — eine motivierende Gemeinschaft' },
      ],
      certifications: 'Swiss Olympic, EFT Personal Trainer, TRX Certified',
    },
  },
  components: {
    header: {
      companyName: 'Fitness Muster',
      logoText: 'FM',
      navItems: ['Trainings', 'Konzept', 'Team', 'Kontakt'],
      ctaText: 'Probetraining',
    },
    hero: {
      title: 'Stärke. Ausdauer. Fokus.',
      subtitle:
        'Personal Training mit System – für nachhaltige Resultate.',
      primaryBtn: 'Probetraining buchen',
      secondaryBtn: 'Angebote',
    },
    trust: {
      items: [
        { value: '1:1', label: 'Betreuung' },
        { value: 'Individuell', label: 'Plan' },
        { value: 'Flexibel', label: 'Zeiten' },
        { value: 'Messbar', label: 'Fortschritt' },
      ],
    },
    services: {
      title: 'Training',
      subtitle: 'Angepasst an dein Ziel.',
      items: [
        {
          icon: '🏋️',
          title: 'Krafttraining',
          text: 'Muskelaufbau, Körperstraffung, Prävention.',
        },
        {
          icon: '🏃',
          title: 'Ausdauer',
          text: 'Cardio, HIIT, Lauftraining.',
        },
        {
          icon: '🧘',
          title: 'Mobility & Recovery',
          text: 'Beweglichkeit, Regeneration, Stressabbau.',
        },
      ],
    },
    benefits: {
      title: 'Warum Personal Training?',
      subtitle: '',
      items: [
        {
          title: 'Individuelle Betreuung',
          text: 'Jede Einheit ist auf dich abgestimmt.',
        },
        {
          title: 'Korrekte Ausführung',
          text: 'Saubere Technik = schnellere Resultate.',
        },
        {
          title: 'Motivation & Konstanz',
          text: 'Verbindliche Termine halten dich auf Kurs.',
        },
      ],
    },
    team: {
      title: 'Unser Team',
      subtitle: 'Qualifizierte Trainer mit Leidenschaft.',
      members: [
        {
          name: 'Jonas Ammann',
          role: 'Inhaber & Head Coach',
          image: '',
          bio: 'Swiss Olympic Trainer, EFT-zertifiziert. Spezialist für Krafttraining und Athletik.',
        },
        {
          name: 'Nina Bachmann',
          role: 'Personal Trainerin & Ernährungsberaterin',
          image: '',
          bio: 'TRX Certified, Functional Training, Ernährungscoaching.',
        },
      ],
    },
    testimonials: {
      title: 'Kundenstimmen',
      items: [
        {
          quote:
            'Endlich ein Training, das funktioniert und Spass macht.',
          author: 'Sarah Brunner',
          role: 'Mitglied seit 2 Jahren',
        },
        {
          quote: 'Dank dem Personal Training habe ich mein Gewichtsziel erreicht — nachhaltig und ohne Crash-Diät.',
          author: 'Marco Roth',
          role: 'Personal Training Kunde',
        },
        {
          quote: 'Die individuelle Betreuung ist top. Man merkt, dass hier Profis am Werk sind.',
          author: 'Lea Huber',
          role: 'Mitglied, Gruppenkurse',
        },
        {
          quote: 'Nach meiner Knie-OP hat mir das gezielte Aufbautraining enorm geholfen. Sehr kompetent.',
          author: 'Beat Keller',
          role: 'Reha-Training',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Brauche ich Vorerfahrung?',
          answer: 'Nein — wir starten genau dort, wo du stehst. Jeder Trainingsplan wird individuell auf dein Level angepasst.',
        },
        {
          question: 'Was kostet eine Mitgliedschaft?',
          answer: 'Unsere Mitgliedschaft startet ab CHF 89 pro Monat inkl. Gerätetraining und Gruppenkurse. Personal Training gibt es ab CHF 120 pro Session.',
        },
        {
          question: 'Kann ich ein Probetraining machen?',
          answer: 'Ja, das Probetraining ist kostenlos und unverbindlich. Du bekommst eine Einführung in die Geräte und ein erstes Beratungsgespräch.',
        },
      ],
    },
    cta: {
      title: 'Probetraining buchen',
      subtitle: 'Unverbindlich kennenlernen und Ziele besprechen.',
      phone: '+41 00 000 00 00',
      email: 'hello@example.ch',
    },
    footer: {
      companyName: 'Fitness Muster',
      tagline: 'Personal Training in deiner Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'hello@example.ch',
    },
  },
});
